import React from 'react'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'
import { Translation } from '@morningtrain/react-translations'
import ForecastSummaryDashboardSmartview from './ForecastSummaryDashboardSmartview'
import ChecklistsTodayDashboardSmartview from './ChecklistsTodayDashboardSmartview'
import Permissions from 'services/Permissions'
import { Can } from '@morningtrain/react-auth'
import MyShiftsSmartview from 'widgets/dashboard/smartviews/MyShiftsSmartview'
import * as UI from 'ui'

export default function DashboardSmartviewNavigation (props) {
  function getActiveClass (tab) {
    if (tab === props.active) {
      return 'btn-outlineDark'
    }
    return 'btn-outlineLight'
  }

  return (
    <UI.ButtonWrap leftAlign>
      <Can permission={Permissions.SHIFTS_ADJUST_FORECAST}>
        <MountSmartviewWithModelOnClick smartview={<ForecastSummaryDashboardSmartview />} replace>
          <button className={'btn text-sm py-3 px-3 ' + getActiveClass('forecast')}>
            {/* <Translation name='dashboard.forecast_summary.title'/> */}
            Forecast
          </button>
        </MountSmartviewWithModelOnClick>
      </Can>
      <Can permission={Permissions.SHIFTS_ADJUST_FORECAST} negate>
        <MountSmartviewWithModelOnClick smartview={<MyShiftsSmartview />} replace>
          <button className={'btn text-sm py-3 px-3 ' + getActiveClass('my_shifts')}>
            <Translation name='dashboard.my_shifts.smartview_menu_item' />
          </button>
        </MountSmartviewWithModelOnClick>
      </Can>
    </UI.ButtonWrap>
  )
}
